import { ChevronRight } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { userDetailsForm } from "../../../formSchemas/signup.form";
import DynamicForms from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { useSignup } from "../state/SelfSignup";
import { setUserDetails } from "../state/signup.action";
import { IUserData} from "../types";
import useButtonStyles from './ButtonStyles';

interface IUserDetailsFormProps { 
    host: string;
}
export function UserDetailsForm({ host }: IUserDetailsFormProps) {
    const { dispatch, userData, callLeadsAPI, emailLookup, salesRef, reseller } = useSignup();
    const { t } = useTranslation();
    const classes = useButtonStyles();
    function onSubmit(data: unknown) {
        const userData = data as IUserData;
        dispatch(setUserDetails(userData));
        callLeadsAPI({
            ...userData,
            referral_code: salesRef || undefined,
            reseller: reseller || undefined,
            onboarding_source: host.toUpperCase(),
            terms: undefined
        });
    }

    return <DynamicForms
        formData={userData}
        onHandleSubmit={onSubmit}
        formKeyName="register-user-details"
        formRows={userDetailsForm(emailLookup, t,host)}
        formButtons={{
            rightButton: {
                type: 'submit', label: "signup.form.userDataButton", endIcon: <ChevronRight />,
                color: EColourPanel.PRIMARY
            },
            rightButtonCustomClassName:classes.root
        }
        }
        useFormOptions={
            {
                reValidateMode: 'onBlur',
                mode: 'onBlur'
            }
        }
    />
}